(function () {
	'use strict';

	/**
	 * @ngdoc components
	 * @name mx.components:mxSearchInput
	 * @module mx.components
	 * @restrict 'E'
	 * @scope {}
	 * @description Rating with stars components
	 * @param {string} label@ - Text to be displayed with rating
	 * @param {int} value= - Current value
	 * @usage <mx-search-input label='Filter actions' value='vm.filterText'></mx-search-input>
	 */
	angular.module('mx.components').component('mxSearchInput', {
		templateUrl: 'mx-search-input/mx-search-input.html',
		controller: MxSearchInputController,
		controllerAs: 'vm',
		bindings: {
			value: '<',
			label: '@',
			onChange: '&',
			disabled: '<',
			debounce: '@',
			tabindex: '@',
			mxAriaLabel: '@',
		},
	});

	MxSearchInputController.$inject = ['$scope'];
	function MxSearchInputController($scope) {
		var vm = this;
		var debouncedSearch;
		var externalValue, internalValue;
		let lockRepeatingSearch = false;

		vm.$onInit = function () {
			var debounceTime = parseInt(vm.debounce);
			debounceTime = isNaN(debounceTime) || debounceTime < 0 ? 300 : debounceTime;
			debouncedSearch = debounceTime
				? $.debounce(debounceTime, function () {
						$scope.$evalAsync(() => search());
				  })
				: () => search();
		};
		vm.search = search;

		Object.defineProperty(vm, 'value', {
			get: function () {
				return externalValue;
			},
			set: function (newValue) {
				externalValue = internalValue = newValue;
			},
		});

		Object.defineProperty(vm, 'internalValue', {
			get: function () {
				return internalValue;
			},
			set: function (newValue) {
				internalValue = newValue;
				debouncedSearch();
			},
		});

		function search(runByEnter) {
			if (internalValue !== externalValue || (runByEnter && !lockRepeatingSearch)) {
				lockRepeatingSearch = runByEnter;

				externalValue = internalValue;
				vm.onChange({ value: externalValue, runByEnter });
			}
		}
	}
})();
